import { PostHogProvider } from 'posthog-js/react';

export const InitPostHogProvider = ({ preview, children }) => {
  const posthogOptions = {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || null,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    session_recording: {
      recordCrossOriginIframes: true
    }
  };
  
  if (preview) {
    return (
      <PostHogProvider
        apiKey={process.env.NEXT_PUBLIC_POSTHOG_KEY}
        options={posthogOptions}
      >
        {children}
      </PostHogProvider>
    );
  }
  
  return <>{children}</>;
}